import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sfl-loading',
  templateUrl: './sfl-loading.component.html',
  styleUrls: ['./sfl-loading.component.scss']
})
export class SflLoadingComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
